<template>
  <div id="app" @dragenter="$event.stopPropagation()">
    <Header />
    <div class="layout">
      <carousel v-model="index" :per-page="1" :mouse-drag="false" :pagination-enabled="false">
        <slide>
          <RegisterJuridical v-model="company" @back="prev" @submit="next" />
        </slide>
        <slide>
          <SlideRenderHelper name="address" :current="currentSlide">
            <Address person-type="PJ" v-model="address" @back="prev" @submit="next" />
          </SlideRenderHelper>
        </slide>
        <slide>
          <SlideRenderHelper name="confirm_create" :current="currentSlide">
            <ConfirmAndCreate
              person-type="PJ"
              :authorization="authorization"
              :company="company"
              :address="address"
              v-model="accountId"
              @back="prev"
              @next="next"
            />
          </SlideRenderHelper>
        </slide>
        <slide>
          <SlideRenderHelper name="completed" :current="currentSlide">
            <Completed />
          </SlideRenderHelper>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import CustomerGoal from '@/views/CustomerGoal'
import PersonType from '@/views/PersonType'
import Register from '@/views/Register'
import PayOps from '@/views/PayOps'
import RegisterJuridical from '@/views/RegisterJuridical'
import ConfirmAndCreate from '@/views/ConfirmAndCreate'
import Address from '@/views/Address'
import Completed from '@/views/Completed'
import ConfirmCode from '@/views/ConfirmCode'
import SlideRenderHelper from './components/SlideRenderHelper'

export default {
  components: {
    SlideRenderHelper,
    ConfirmCode,
    Completed,
    Address,
    ConfirmAndCreate,
    RegisterJuridical,
    PayOps,
    Register,
    PersonType,
    CustomerGoal,
    Header
  },
  props: {
    authorization: String
  },
  data() {
    return {
      index: 0,
      company: {},
      address: {}
    }
  },
  methods: {
    prev() {
      this.index -= 1
    },
    next() {
      this.index += 1
    },
    confirmHandler({ verified }) {
      verified && this.next()
    }
  },
  computed: {
    currentSlide() {
      const { index } = this
      if (index === 0) {
        return 'register_juridical'
      }
      if (index === 1) {
        return 'address'
      }
      if (index === 2) {
        return 'confirm_create'
      }
      return 'completed'
    }
  },
  mounted() {
    this.processQuery = this.processQuery.bind(this)
    this.processQuery()
  }
}
</script>

<style lang="scss">
$fa-font-path: '~/assets/fonts/fontawesome';

@import './assets/scss/main';

button:disabled {
  border-color: #f2f5fa !important;
  background-color: #f2f5fa !important;
  color: #5b5e63;
}
</style>
